const choices = {
    depreciable: 'Amortissable',
    'in-fine': 'In fine',
};

export default choices;
